module.exports = __webpack_public_path__ + "static/pinkmummyme1-68e990cdf1293cadb84e59b02220c20c.png";